import React, { useEffect, useState } from 'react'
import { FaSearch, FaBell, FaPlus, FaInbox, FaCodeBranch,FaList } from "react-icons/fa";
import { useLocation } from 'react-router';
import StaffAdminCreate from './StaffAdminCreate';
import StaffAdminEdit from './StaffAdminEdit';
import StaffAdminRead from './StaffAdminRead';
import StaffAdminList from './StaffAdminList';

function StaffAdmin() {

  const location = useLocation()
  const [activeAction,setActiveAction] = useState("staff-list-view")

  const navItems = [
    { label: 'Create Staff',  path: '/staff/profile/create',tab:'create-staff' },
    { label: 'Staff',  path: '/staff/profile/detail',tab:'staff-detail-view'  },
    { label: 'Edit Staff',  path: '/staff/profile/edit',tab:'edit-staff' },
    { label: 'List Staff',  path: '/staff/profile',tab:'list-staff' },
  ];

  
   useEffect(()=>{
      console.log(location)
      if(location?.pathname==="/staff/profile/create/" && activeAction !== "create-staff"){
        setActiveAction("create-staff")
      }else if(location?.pathname==="/staff/profile/detail/"  && activeAction !== "staff-detail-view"){
        setActiveAction("staff-detail-view")
      }else if(location?.pathname.includes("/staff/profile/detail/") && activeAction !== "staff-detail-view"){
        setActiveAction("staff-detail-view")
      }else if(location?.pathname==="/staff/profile/edit/" && activeAction !== "edit-staff"){
        setActiveAction("staff-view")
      }else if(location?.pathname==="/staff/profile/" && activeAction !== "list-staff"){
        setActiveAction("list-staff")
      }
    },[location?.pathname])

     useEffect(()=>{
        if(location?.state?.redirect){
          setActiveAction(location?.state?.redirect)
        }
      },[location])

    const CreateStaff = (e)=>{
      e.preventDefault()
      setActiveAction("create-staff")
    }

    const EditStaff = (e)=>{
      e.preventDefault()
      setActiveAction("edit-staff")
    }

    const ListStaff = (e)=>{
      e.preventDefault()
      setActiveAction("list-staff")
    }


    const views = {
      "create-staff":<StaffAdminCreate/>,
      "create-edit":<StaffAdminEdit/>,
      "staff-detail-view":<StaffAdminRead/>,
      "list-staff": <StaffAdminList/>
    }

  return (
    <div>
            {/* <h3>ProjectAdmin</h3> */}
        <header className="projects-header-admin">
          <h1 className="header-title-admin">My Staff Admin</h1>
    
          <div className="header-controls-admin">
            <div className="search-container">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Type / to search"
                className="search-input"
              />
            </div>
    
            <div className="icon-group">
              <button className="icon-button tooltip-container" onClick={CreateStaff}>
                <FaPlus /> <span>New Staff</span> <span class="tooltip-content">Add New Staff</span>
              </button>
              <button className="icon-button tooltip-container" onClick={ListStaff}>
                <FaList /> <span>View Staff</span> <span class="tooltip-content">List All Staffs</span>
              </button>
              <button className="icon-button">
                <FaCodeBranch />
              </button>
              <button className="icon-button">
                <FaInbox />
              </button>
            </div>
          </div>
        </header>
        <div>
          {
            views[activeAction] || views['list-staff']
          }
        </div>
        </div>
  )
}

export default StaffAdmin

// New Organisation
// New Partner
// New Categories
// 